import axios from "axios";

export default function uploadAttachment({ ticketId, file, commentId }) {
  const formData = new FormData();
  formData.append("file", file);
  if (commentId) formData.append("comment_id", commentId);
  return new Promise((resolve, reject) =>
    axios
      .post(`/support/api/v1/admin/tickets/${ticketId}/attachments`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
